import { jsx as _jsx } from "react/jsx-runtime";
import UIImage from 'UIComponents/image/UIImage';
import styled from '../../../utils/Styling';
const ThumbnailImageContainer = styled.div.withConfig({
  displayName: "ThumbnailImage__ThumbnailImageContainer",
  componentId: "sc-1trzyma-0"
})(["aspect-ratio:1;height:100%;"]);

const ThumbnailImage = ({
  name,
  src
}) => {
  const hasSrc = src && src.length;
  return /*#__PURE__*/_jsx(ThumbnailImageContainer, {
    children: hasSrc && /*#__PURE__*/_jsx(UIImage, {
      alt: name,
      shape: "circle",
      src: src
    })
  });
};

export default ThumbnailImage;